__turbopack_context__.v({
  "Cont": "Points-module-sass-module__5JgsMa__Cont",
  "Copy": "Points-module-sass-module__5JgsMa__Copy",
  "Link": "Points-module-sass-module__5JgsMa__Link",
  "Main": "Points-module-sass-module__5JgsMa__Main",
  "Point": "Points-module-sass-module__5JgsMa__Point",
  "Points": "Points-module-sass-module__5JgsMa__Points",
  "PointsGrid": "Points-module-sass-module__5JgsMa__PointsGrid",
});
